import LineBuildingIcon from 'components/Luxkit/Icons/line/LineBuildingIcon'
import ListItemLoadingSkeleton from 'components/Luxkit/List/ListItemLoadingSkeleton'
import React from 'react'

function BusinessTravellerAccountListItemLoading() {
  return <ListItemLoadingSkeleton startIcon={<LineBuildingIcon />} subtitleWidth="100%" />
}

export default BusinessTravellerAccountListItemLoading
